import React, { useEffect, useMemo, useState } from "react";
import { useParams } from 'react-router';
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import ROUTES from "../../../../utilities/Routes";

import ButtonBack from "../../../../components/Buttons/Back";
import InputText from "../../../../components/Inputs/Text";
import InputSelect from "../../../../components/Inputs/Select";
import InputTextArea from "../../../../components/Inputs/TextArea";
import InputCheckBox from "../../../../components/Inputs/Checkbox";
import Loader from '../../../../components/Loader';
import ReactLoading from "react-loading";

import { validarApellidoPaterno, validarCelular, validarCorreo, validarNombre, validarTelefono } from "../../../../utilities/Validations/lead";
import { validateText } from "../../../../utilities/Validations";
import { getOnlyAudiCenters, scrollToInput } from "../../../../utilities/utils";

import años from '../../../../data/CompramosTuAuto/años.json'
import marcas from '../../../../data/CompramosTuAuto/marcas.json'
import kilometrajes from '../../../../data/CompramosTuAuto/kilometrajes.json'
import listaConcesionarios from '../../../../data/CompramosTuAuto/concesionarios.json'
import metaPixelIds from '../../../../data/CompramosTuAuto/metaPixelIds.json'

import MetaPixel from "../../../../plugins/audicenter/compraDeAuto/metaPixel";

import {
    setTratamientoAction,
    setNombreAction,
    setApellidoPaternoAction,
    setTelefonoAction,
    setMovilAction,
    setCorreoAction,
    setEstadoAction,
    setCiudadAction,
    setIdConcesionarioAction,
    setConcesionarioAction,
    setAnoVehiculoAction,
    setModeloVehiculoAction,
    setColorVehiculoAction,
    setMarcaVehiculoAction,
    setVersionVehiculoAction,
    setKilometrajeVehiculoAction,
    setComentariosAction,
    setAvisosDePrivacidadAction,
    // setTerminosCondicionesAction,
    setLegalesAction,
    setUrlHomeDealerAction,
    reiniciarStateAction
} from "../../../../actions/compramosTuAuto";

import {
    getEstados,
    getConcesionarios,
} from "../../../../API/CitasServicioRequest/index";

import {
    getCiudades,
} from "../../../../API/ConfiguradorRequest/index";

import {
    isOnlyNumbers,
} from "../../../../utilities/Validations";
import { sendMailCompraDeAutoCliente, sendMailCompraDeAutoConcesionaria } from "../../../../API/CompramosTuAutoRequest";
import { TratoComponent } from "../../../../components/Form/Trato";

const FormAudiNuevo = () => {
    const dispatch = useDispatch();
    const objSubmit = useSelector((state) => state.compramosTuAuto);

    const { concesionaria } = useParams();
    let navigate = useNavigate();
    const pixelMetaInfo = metaPixelIds.find((item) => item.dealerNumber === concesionaria);

    const setTratamiento = (inTratamiento) => {
        dispatch(setTratamientoAction(inTratamiento));
    };
    const setNombre = (inNombre) => {
        dispatch(setNombreAction(inNombre));
    };
    const setApellidoPaterno = (inApellidoPaterno) => {
        dispatch(setApellidoPaternoAction(inApellidoPaterno));
    };
    const setTelefono = (inTelefono) => {
        dispatch(setTelefonoAction(isOnlyNumbers(inTelefono)));
    };
    const setMovil = (inMovil) => {
        dispatch(setMovilAction(isOnlyNumbers(inMovil)));
    };
    const setCorreo = (inCorreo) => {
        dispatch(setCorreoAction(inCorreo));
    };
    const setEstado = (inEstado) => {
        dispatch(setEstadoAction(inEstado));
    };
    const setCiudad = (inCiudad) => {
        dispatch(setCiudadAction(inCiudad));
    };
    const setIdConcesionario = (inIdConcesionario) => {
        dispatch(setIdConcesionarioAction(inIdConcesionario));
    };
    const setConcesionario = (inConcesionario) => {
        dispatch(setConcesionarioAction(inConcesionario));
    };
    const setAnoVehiculo = (inAnoVehiculo) => {
        dispatch(setAnoVehiculoAction(inAnoVehiculo));
    };
    const setModeloVehiculo = (inModeloVehiculo) => {
        dispatch(setModeloVehiculoAction(inModeloVehiculo));
    };
    const setColorVehiculo = (inColorVehiculo) => {
        dispatch(setColorVehiculoAction(inColorVehiculo));
    };
    const setMarcaVehiculo = (inMarcaVehiculo) => {
        dispatch(setMarcaVehiculoAction(inMarcaVehiculo));
    };
    const setVersionVehiculo = (inVersionVehiculo) => {
        dispatch(setVersionVehiculoAction(inVersionVehiculo));
    };
    const setKilometrajeVehiculo = (inKilometrajeVehiculo) => {
        dispatch(setKilometrajeVehiculoAction(inKilometrajeVehiculo));
    };
    const setComentarios = (inComentarios) => {
        dispatch(setComentariosAction(inComentarios));
    };
    const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
        dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
    };
    const setUrlHomeDealer = (inUrlHomeDealer) => {
        dispatch(setUrlHomeDealerAction(inUrlHomeDealer));
    };
    // const setTerminosCondiciones = (inTerminosCondiciones) => {
    //     dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
    // };
    const setLegales = (inLegales) => {
        dispatch(setLegalesAction(inLegales));
    };

    const [actualDealer, setActualDealer] = useState(null);

    const [estados, setEstados] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [concesionarios, setConcesionarios] = useState([]);
    const [urlAvisoDePrivacidad, setUrlAvisoDePrivacidad] = useState(null);

    const [showErrorServicios, setShowErrorServicios] = useState(false);
    const [showErrorEstado, setErrorEstado] = useState(false);
    const [showErrorCiudad, setErrorCiudad] = useState(false);
    const [showErrorConcesionario, setErrorConcesionario] = useState(false);
    const [showErrorAnoVehiculo, setShowErrorAnoVehiculo] = useState(false);
    const [showErrorKilometraje, setShowErrorKilometraje] = useState(false);
    const [showErrorMarca, setShowErrorMarca] = useState(false);
    const [showInputTextMarca, setShowInputTextMarca] = useState(false);
    const [showErrorLegal, setErrorLegal] = useState(false);
    const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrorSubmit, setShowErrorSubmit] = useState(false);

    const filterCiudades = useMemo(() => {
        if (estados.length > 0 && ciudades.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.estado
            );

            if (estadoSelected === undefined) return [];

            return ciudades.filter(
                (cd) => cd.idestado.idestado === estadoSelected.idestado
            );
        }
        return [];
    }, [objSubmit, estados, ciudades]);

    const filterConcesionarios = useMemo(() => {
        if (concesionarios.length > 0 && estados.length > 0) {
            const estadoSelected = estados.find(
                (edo) => edo.nombreedo === objSubmit.estado
            );

            if (estadoSelected === undefined) return [];

            return concesionarios.filter(
                (concesionario) => concesionario.stateName === estadoSelected.nombreedo
            );
        }
        return [];
    }, [objSubmit.estado, estados, concesionarios]);

    useEffect(() => {
        document.title = "Compramos tu Auto";
        setLoading(true);
        setShowErrorServicios(false);

        if (process.env.REACT_APP_ENABLE_GA4 === "true") {
            // Se inicializa el objeto de analytics para el sitio
            ReactGA.initialize(process.env.REACT_APP_COMPRAMOS_TU_AUTO_GA_ID);
        }

        if (concesionaria !== undefined) {
            document.title = "Compramos tu auto - " + concesionaria;
        } else {
            document.title = "Compramos tu auto - General";
            // ({ hitType: "pageview", page: "/citas-de-servicio/agendar", title: "Citas de servicio - General"});
        }

        const funGetEstado = async () => {
            try {
                const responseEstados = await getEstados();
                setEstados(responseEstados.data);

                return responseEstados.data;
            } catch (error) {
                console.error("Obtener Estados: ", error);
                throw error;
            }
        };
        const funGetCiudades = async () => {
            try {
                const responseCiudades = await getCiudades();
                setCiudades(responseCiudades.data);

                return responseCiudades.data;
            } catch (error) {
                console.error("Obtener Ciudades: ", error);
                throw error;
            }
        };

        const funGetConcesionarios = async () => {
            try {
                const responseConcesionarios = await getConcesionarios();
                const filterConcesionarios = getOnlyAudiCenters(responseConcesionarios.data.data);
                if (concesionaria === undefined) {
                    /**
                     * Envia evento de analytics de Form Compramos tu Auto
                     */
                    console.log("Es form general");
                } else {
                    /**
                     * Busca si el parametro pertenece a algun concesionario
                     */
                    const concesionarioActual = filterConcesionarios.find((dealer) => parseInt(concesionaria) === dealer.dealerNumber);
                    if (concesionarioActual) {
                        /**
                         * Si existe el concesionario en el listado
                         * Agregamos la informacion al store
                         */
                        // console.log(concesionarioActual);
                        setUrlAvisoDePrivacidad(getAvisoDePrivacidadConcesionaria(concesionarioActual))
                        setUrlHomeDealer(getHomeConcesionaria(concesionarioActual));
                        setActualDealer(concesionarioActual);
                        setConcesionario(concesionarioActual.name)
                        setIdConcesionario(concesionarioActual.dealerNumber)
                        setEstado(concesionarioActual.stateName)
                        setCiudad(concesionarioActual.cityName)

                    } else {
                        /**
                         * No se encuentra el concesionaria, se borra el parametro y se muestra el form general
                         */
                        throw new Error("No se encontro la información del concesionario");
                    }
                }

                setConcesionarios(filterConcesionarios);
                return filterConcesionarios;
            } catch (error) {
                console.error("Obtener concesionarios: ", error);
                throw error;
            }

        };

        Promise.all([funGetEstado(), funGetCiudades(), funGetConcesionarios()])
            .then(() => {
                // Oculta el loading
                setLoading(false);
            })
            .catch(error => {
                // Maneja cualquier error que pueda ocurrir
                console.error(error);
                // Oculta el loading y mostrar el error
                setLoading(false);
                setShowErrorServicios(true);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [concesionaria]);

    const onSubmit = (e) => {
        e.preventDefault();

        const dataIsvalid = validateForm();

        if (dataIsvalid) {

            setLoadingSubmit(true);
            setShowErrorSubmit(false);
            const lead = { ...objSubmit };

            const contactos = getContactosConcesionaria(objSubmit.numeroConcesionaria)

            // console.log(contactos, urlAvisoDePrivacidad[1]);

            setLoadingSubmit(false);

            sendMailCompraDeAutoCliente({ ...lead, urlAvisoDePrivacidad })
            sendMailCompraDeAutoConcesionaria({ ...lead, contactos, urlAvisoDePrivacidad })
            dispatch(reiniciarStateAction());

            if (ReactGA.isInitialized) {
                ReactGA.event('lead_sended', {
                    category: "Compramos tu auto",
                    action: "Lead enviado exitosamente",
                    label: "Nuevo Lead Compramos tu auto", // optional
                    once: true // Solo se envia una vez
                });
            }

            concesionaria === undefined
                ? navigate(ROUTES.COMPRAMOSTUAUTOTHANKYOUEMPTY)
                : navigate(ROUTES.COMPRAMOSTUAUTOTHANKYOUEMPTY + "/" + concesionaria)

        }

    }

    const getContactosConcesionaria = (numeroConcesionaria) => {
        const concesionariaActual = listaConcesionarios.find((dealer) => parseInt(numeroConcesionaria) === dealer.dealerNumber);

        if (concesionariaActual === null) return []

        let contactos =
            concesionariaActual?.contactosConfigurador.split(";").length > 0
                ? concesionariaActual?.contactosConfigurador.split(";").map((item) => item.trim())
                : [];

        return contactos
    }

    const getAvisoDePrivacidadConcesionaria = (concesionariaActual) => {

        if (concesionariaActual?.contactos === null) return []

        const urlAvisoDePrivacidad = concesionariaActual?.contactos.split(",").length > 8 ? concesionariaActual?.contactos.split(",")[4].split(";").map(item => item.trim()) : "";

        return urlAvisoDePrivacidad;
    }

    const getHomeConcesionaria = (concesionarioActual) => {

        if (concesionarioActual?.contactos === null) return ""

        const urlHomeConcesionaria = concesionarioActual?.contactos.split(",").length > 8 ? concesionarioActual?.contactos.split(",")[0].split(";").map(item => item.trim()) : "";

        return urlHomeConcesionaria[0];
    }

    const validateForm = () => {
        if (validarNombre(objSubmit.nombre) === false) {
            scrollToInput("nombre", "Por favor ingresa un nombre válido");
            return false
        }
        if (validarApellidoPaterno(objSubmit.apellidoPaterno) === false) {
            scrollToInput("apellidoPaterno", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarTelefono(objSubmit.telefono) === false) {
            scrollToInput("telefono", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCelular(objSubmit.celular) === false) {
            scrollToInput("movil", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCorreo(objSubmit.email) === false) {
            scrollToInput("correo", "Por favor ingresa un valor válido");
            return false;
        }
        if (objSubmit.estado === "") {
            scrollToInput("estado");
            setErrorEstado(true);
            return false;
        } else {
            setErrorEstado(false);
        }
        if (objSubmit.ciudad === "") {
            scrollToInput("ciudad");
            setErrorCiudad(true);
            return false;
        } else {
            setErrorCiudad(false);
        }
        if (actualDealer === null) {
            if (objSubmit.numeroConcesionaria === "" || objSubmit.concesionariaPreferida === "") {
                scrollToInput("concesionario");
                setErrorConcesionario(true);
                return false;
            } else {
                setErrorConcesionario(false);
            }

        }
        if (objSubmit.anoVehiculo === "") {
            scrollToInput("año");
            setShowErrorAnoVehiculo(true);
            return false;
        } else {
            setShowErrorAnoVehiculo(false);
        }
        if (objSubmit.modeloVehiculo === "") {
            scrollToInput("modelo", "Por favor ingresa un valor.");
            return false
        }
        if (objSubmit.colorVehiculo === "" || validateText(objSubmit.colorVehiculo) === false) {
            scrollToInput("color", "Por favor ingresa un valor válido");
            return false
        }
        if (!showInputTextMarca && objSubmit.marcaVehiculo === "") {
            scrollToInput("marca");
            setShowErrorMarca(true);
            return false;
        } else {
            setShowErrorMarca(false);
        }
        if ((showInputTextMarca && objSubmit.marcaVehiculo === "") || validateText(objSubmit.marcaVehiculo) === false) {
            scrollToInput("otroVehiculo", "Por favor ingresa un valor.");
            return false;
        }
        if (objSubmit.versionVehiculo === "") {
            scrollToInput("version", "Por favor ingresa un valor.");
            return false
        }
        if (objSubmit.kilometrajeVehiculo === "") {
            scrollToInput("kilometraje");
            setShowErrorKilometraje(true);
            return false;
        } else {
            setShowErrorKilometraje(false);
        }
        if (objSubmit.descripcion.length > 1000) {
            scrollToInput("comentarios");
            return false;
        }

        if (objSubmit.legales === false) {
            setErrorLegal(true);
            return false;
        } else {
            setErrorLegal(false);
        }
        if (
            objSubmit.avisoPrivacidad === false
        ) {
            setErrorDeclaraciones(true);
            return false;
        } else {
            setErrorDeclaraciones(false);
        }

        return true
    }

    if (loading) {
        return <Loader />;
    }
    if (showErrorServicios) {
        return <div
            className="loading-g d-vertical-center loading-btn"
            style={{ height: "calc(100vh - 72px)" }}
        >
            <div>
                <span>Error en los servicios, porfavor intente más tarde.</span>
            </div>
        </div>;
    }

    return (
        <>
            {
                (process.env.REACT_APP_ENABLE_META_PIXEL === "true" && pixelMetaInfo) && <MetaPixel id={pixelMetaInfo.id} />
            }
            <main className="compramos-tu-auto">
                <div className="container mt-4 mb-5 w-100">
                    <ButtonBack url={objSubmit.urlHomeDealer} top />
                </div>
                <section className="container w-100 pt-2">
                    <p className="mb-5">
                        Encuentra con nosotros la mejor oferta para vender tu auto de manera rápida, práctica y segura que solo Audi puede ofrecerte.
                        Solo ingresa la información de tus datos de contacto y tu vehículo.
                    </p>
                    <form className="w-100 pt-5" onSubmit={onSubmit}>
                        <TratoComponent value={objSubmit.tratamiento} onChange={(e) => {setTratamiento(e.target.value)}}/>
                        <h3>Datos de contacto</h3>
                        <div className="fields-grid mt-4 mb-5">
                            <div className="order-1">
                                <InputText
                                    label="¿Cuál es tu nombre?"
                                    name="nombre"
                                    maxLength={40}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        e.target.value = value;
                                        setNombre(value);
                                    }}
                                    errorMessage="Carácter no válido, por favor use solo letras."
                                    validator={validarNombre}
                                />
                            </div>
                            <div className="order-2">
                                <InputText
                                    label="¿Cuál es tu apellido?"
                                    name="apellidoPaterno"
                                    maxLength={80}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim();
                                        e.target.value = value;
                                        setApellidoPaterno(value);
                                    }}
                                    errorMessage="Carácter no válido, por favor use solo letras."
                                    validator={validarApellidoPaterno}
                                />

                            </div>
                            <div className="order-3">
                                <InputText
                                    label="¿Cuál es tu número de teléfono?"
                                    name="telefono"
                                    value={objSubmit.telefono}
                                    maxLength={10}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10)
                                            setTelefono(e.target.value);
                                    }}
                                    errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                    validator={validarTelefono}
                                />
                            </div>
                            <div className="order-4 order-xl-5">
                                <InputText
                                    label="¿Cuál es tu número móvil?"
                                    name="movil"
                                    value={objSubmit.celular}
                                    maxLength={10}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10)
                                            setMovil(e.target.value);
                                    }}
                                    errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                    validator={validarCelular}
                                />
                            </div>
                            <div className="order-5 order-xl-7">
                                <InputText
                                    label="¿Cuál es tu e-mail?"
                                    name="correo"
                                    maxLength={80}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 80)
                                            setCorreo(e.target.value);
                                    }}
                                    errorMessage="Por favor use un e-mail válido con formato: nombre@dominio.com"
                                    validator={validarCorreo}
                                />
                            </div>

                            {
                                actualDealer === null && <>
                                    <div className="order-6 order-xl-4">
                                        <InputSelect
                                            label="Estado"
                                            name="estado"
                                            options={estados.map((item, i) => ({
                                                value: item.nombreedo,
                                                label: item.nombreedo,
                                            }))}
                                            onChange={(e) => {
                                                setEstado(e.target.value);
                                                setCiudad("");
                                                setIdConcesionario("");
                                                setConcesionario("");
                                                setErrorEstado(false);
                                            }}
                                            errorMessage="Selecciona una opción"
                                            showError={showErrorEstado}
                                            defaultValue={objSubmit.estado}
                                        />
                                    </div>
                                    <div className="order-7 order-xl-6">
                                        <InputSelect
                                            label="Ciudad"
                                            name="ciudad"
                                            options={filterCiudades.map((item, i) => ({
                                                value: item.nombrecd,
                                                label: item.nombrecd,
                                            }))}
                                            onChange={(e) => {
                                                setCiudad(e.target.value);
                                                setErrorCiudad(false);
                                            }}
                                            disabled={objSubmit.provincia === ""}
                                            showError={showErrorCiudad}
                                            errorMessage="Selecciona una opción"
                                            defaultValue={objSubmit.ciudad}
                                        />
                                    </div>
                                </>
                            }
                            {
                                actualDealer === null && <div className="order-8">
                                    <InputSelect
                                        label="Concesionario"
                                        name="concesionario"
                                        options={filterConcesionarios.map((item, i) => ({
                                            value: item.dealerNumber,
                                            label: item.name,
                                        }))}
                                        onChange={(e) => {
                                            const concesionario = concesionarios.find(
                                                (con) => con.dealerNumber === parseInt(e.target.value)
                                            );

                                            setIdConcesionario(concesionario.dealerNumber);
                                            setConcesionario(concesionario.name);
                                            setErrorConcesionario(false);
                                        }}
                                        showError={showErrorConcesionario}
                                        noDataMessage={objSubmit.estado === "" ? "Para seleccionar el concesionario, por favor, primero selecciona tu estado" : "No hay concesionarios, por favor, selecciona otro estado."}
                                        showNoDataMessage={objSubmit.estado !== ""}
                                        errorMessage="Selecciona una opción"
                                        defaultValue={objSubmit.numeroConcesionaria}
                                    />
                                </div>
                            }
                        </div>
                        <h3 className="pt-5">Información del vehículo</h3>
                        <div className="fields-grid mt-4 mb-5">
                            <div className="order-1">
                                <InputSelect
                                    label="¿Qué año es tu auto?"
                                    name="año"
                                    defaultValue={objSubmit.anoVehiculo}
                                    options={años.map((item) => ({
                                        value: item,
                                        label: item,
                                    }))}
                                    onChange={(e) => {
                                        setAnoVehiculo(e.target.value);
                                        setShowErrorAnoVehiculo(false);
                                    }}
                                    errorMessage="Selecciona una opción"
                                    showError={showErrorAnoVehiculo}
                                />
                            </div>
                            <div className="order-2">
                                {
                                    !showInputTextMarca &&
                                    <InputSelect
                                        label="¿Qué marca es tu auto?"
                                        name="marca"
                                        defaultValue={objSubmit.marcaVehiculo}
                                        options={marcas.map((item, i) => ({
                                            label: item,
                                            value: item,
                                        }))}
                                        onChange={async (e) => {
                                            if (e.target.value === "Otra") {
                                                await setShowInputTextMarca(true);
                                                setMarcaVehiculo("");
                                                document.getElementById("otroVehiculo").focus();
                                            } else {
                                                setMarcaVehiculo(e.target.value);
                                                setShowErrorMarca(false);
                                            }
                                        }}
                                        showError={showErrorMarca}
                                    />
                                }
                                {
                                    showInputTextMarca &&
                                    <InputText
                                        id="otroVehiculo"
                                        label="¿Qué marca es tu auto?"
                                        name="otroVehiculo"
                                        maxLength={40}
                                        value={objSubmit.marcaVehiculo}
                                        onChange={(e) => {
                                            const value = e.target.value.trim();
                                            setMarcaVehiculo(value);
                                        }}
                                        errorMessage="Por favor ingresa un valor válido"
                                        validator={validateText}
                                    />
                                }
                            </div>
                            <div className="order-3">
                                <InputText
                                    label="¿Qué modelo es tu auto?"
                                    name="modelo"
                                    maxLength={40}
                                    value={objSubmit.modeloVehiculo}
                                    onChange={(e) => {
                                        const value = e.target.value.trim();
                                        setModeloVehiculo(value);
                                    }}
                                    errorMessage="Por favor ingresa un valor válido"
                                />
                            </div>
                            <div className="order-4">
                                <InputText
                                    label="¿Qué versión es tu auto?"
                                    name="version"
                                    maxLength={40}
                                    value={objSubmit.versionVehiculo}
                                    onChange={(e) => {
                                        const value = e.target.value.trim();
                                        setVersionVehiculo(value);
                                    }}
                                    errorMessage="Por favor ingresa un valor válido"
                                />
                            </div>
                            <div className="order-5">
                                <InputText
                                    label="¿Qué color es tu auto?"
                                    name="color"
                                    maxLength={40}
                                    value={objSubmit.colorVehiculo}
                                    onChange={(e) => {
                                        const value = e.target.value.trim();
                                        setColorVehiculo(value);
                                    }}
                                    errorMessage="Por favor ingresa un valor válido"
                                    validator={validateText}
                                />
                            </div>
                            <div className="order-6">
                                <InputSelect
                                    label="¿Qué kilometraje tiene tu auto?"
                                    name="kilometraje"
                                    defaultValue={objSubmit.kilometrajeVehiculo}
                                    options={kilometrajes.map((item, i) => ({
                                        label: item,
                                        value: item,
                                    }))}
                                    onChange={(e) => {
                                        setKilometrajeVehiculo(e.target.value);
                                        setShowErrorKilometraje(false);
                                    }}
                                    showError={showErrorKilometraje}
                                />
                            </div>
                        </div>
                        <div>
                            <InputTextArea
                                name="comentarios"
                                placeholder="Escribe aquí las dudas o información que te gustaría conocer."
                                errorMessage="Tu comentario excede los 1,000 caracteres"
                                onChange={(e) => {
                                    setComentarios(e.target.value);
                                }}
                                isValid={true}
                            />
                        </div>
                        <div className="pt-5">
                            <p className="">
                                *Propuesta de compra a reserva de diagnóstico mecánico y validación de documentos. Aplica solo para modelos 2019 a la fecha y con
                                kilometraje máximo de 50,000 km. Consulta marcas y modelos participantes.<br /><br /><br />
                            </p>
                            <InputCheckBox
                                onChange={(e) => {
                                    setLegales(e.target.checked);
                                }}
                            >
                                <span>
                                    He leído y acepto el legal.
                                </span>
                            </InputCheckBox>
                            <span
                                className={`inValid-input ${showErrorLegal ? "" : "d-none"
                                    }`}
                            >
                                Para continuar, acepta el legal.
                            </span>
                            <h3 className="mt-5">Estamos comprometidos con tu privacidad</h3>
                            <p className="mt-4 pb-5">
                                Audi usa la información que proporcionas para ofrecerte contenido de valor sobre los productos y servicios con los que contamos a través de un contacto personalizado. Permítenos brindarte una mejor experiencia al aceptar los siguientes avisos:
                            </p>

                            <div className="d-flex flex-column gap-3">
                                {/* <InputCheckBox
                                    rounded
                                    label="Aceptar todo"
                                    onChange={(e) => {

                                        var checkboxes =
                                            document.getElementsByName("checkboxgroup");

                                        checkboxes.forEach((cbx) => {
                                            cbx.checked = e.target.checked;
                                        });
                                        setAvisosDePrivacidad(e.target.checked);
                                        setTerminosCondiciones(e.target.checked);
                                    }}
                                /> */}

                                <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setAvisosDePrivacidad(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href={actualDealer === null ? process.env.REACT_APP_AVISO_PRIVACIDAD : urlAvisoDePrivacidad[1]}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Aviso de Privacidad.
                                        </a>
                                    </span>
                                </InputCheckBox>
                                {/* <InputCheckBox
                                    name="checkboxgroup"
                                    onChange={(e) => {
                                        setTerminosCondiciones(e.target.checked);
                                    }}
                                >
                                    <span>
                                        He leído y acepto el{" "}
                                        <a
                                            href="https://www.audi.com.mx/es/tools/navigation/layer/imprint/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Términos y Condiciones.
                                        </a>
                                    </span>
                                </InputCheckBox> */}

                                <span
                                    className={`inValid-input ${showErrorDeclaraciones ? "" : "d-none"
                                        }`}
                                >
                                    Para continuar, acepta nuestras declaraciones de conformidad.
                                </span>

                            </div>

                        </div>
                        <div>
                            {!loadingSubmit ? (
                                <button className={`button-enviar`} type="submit">
                                    Enviar
                                </button>
                            ) : (
                                <button
                                    className="button-enviar disabled"
                                    type="button"
                                    disabled={true}
                                >
                                    <div className="loading-g loading-send loading-btn">
                                        <div>
                                            <ReactLoading
                                                type="cylon"
                                                color="#fff"
                                                width={"100%"}
                                                height={"58px"}
                                            />
                                        </div>
                                    </div>
                                </button>
                            )}
                        </div>
                        <span
                            className={`mb-5 inValid-input d-block ${!showErrorSubmit ? "d-none" : ""
                                }`}
                        >
                            Hubo un error. Por favor, Intentelo más tarde.
                        </span>
                    </form>
                </section>
            </main >
        </>
    );
};

export default FormAudiNuevo;